import script from "./EditSeasonPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditSeasonPage.vue?vue&type=script&setup=true&lang=ts"

import "./EditSeasonPage.vue?vue&type=style&index=0&id=3baa0bff&lang=css"

const __exports__ = script;

export default __exports__